import { TOKEN, apiUrl } from "../Constants"
import api from "./ApiService"

const BASE_URL = apiUrl + "/api/send-otp"

export function sendOTP(data: any) {
  return api.get(`${BASE_URL}?mobile_number=${data.mobile_number}`)
}

export function sendMsg(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.post(`${BASE_URL}/send-sms-msg`, data, config)
}
